import { createFeature, createReducer, on } from '@ngrx/store';

import { ExternalBuyerMappingsActions } from '../actions/external-buyer-mappings.actions';
import { INITIAL_EXTERNAL_BUYER_MAPPINGS_STATE } from '../external-buyer-mappings.state';

export const externalBuyerMappingsFeatureKey = 'externalBuyerMappings';

export const externalBuyerMappingsReducer = createReducer(
  INITIAL_EXTERNAL_BUYER_MAPPINGS_STATE,

  on(ExternalBuyerMappingsActions.uploadMappings, (state) => ({
    ...state,
    uploadStatus: 'loading' as const,
    uploadError: null,
  })),

  on(
    ExternalBuyerMappingsActions.uploadMappingsSuccess,
    (state, { count }) => ({
      ...state,
      uploadStatus: 'success' as const,
      uploadSuccessCount: count,
      uploadError: null,
    }),
  ),

  on(
    ExternalBuyerMappingsActions.uploadMappingsFailure,
    (state, { error }) => ({
      ...state,
      uploadStatus: 'error' as const,
      uploadError: error,
    }),
  ),

  on(ExternalBuyerMappingsActions.uploadMappingsReset, (state) => ({
    ...state,
    uploadStatus: 'idle' as const,
    uploadSuccessCount: null,
    uploadError: null,
  })),

  on(ExternalBuyerMappingsActions.downloadMappings, (state) => ({
    ...state,
    downloadStatus: 'loading' as const,
    downloadError: null,
  })),

  on(ExternalBuyerMappingsActions.downloadMappingsSuccess, (state) => ({
    ...state,
    downloadStatus: 'idle' as const,
  })),

  on(
    ExternalBuyerMappingsActions.downloadMappingsFailure,
    (state, { error }) => ({
      ...state,
      downloadStatus: 'error' as const,
      downloadError: error,
    }),
  ),

  on(ExternalBuyerMappingsActions.downloadMappingsReset, (state) => ({
    ...state,
    downloadStatus: 'idle' as const,
    downloadError: null,
  })),
);

export const externalBuyerMappingsFeature = createFeature({
  name: externalBuyerMappingsFeatureKey,
  reducer: externalBuyerMappingsReducer,
});
